/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import MenuSideBar from "./MenuSideBar";
import { useNavigate } from "react-router";
import {
  CREATE_SCENE,
  USER_STUDIO_WALL,
} from "../../../../../../../../../actions/sceneActions";
import { getWidgetWallData } from "../../../../../../../../../actions/wallDataAction";
import { getInitialRoute } from "../../../../../../../../../utils";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "../../../../../../../../CommonComponents/AssetsHelper";


const AsideMenuList = (props) => {
  const navigate = useNavigate();
  return <AM {...props} navigate={navigate} />;
};
class AM extends Component {
  state = {
    newLayout: {},
    selectedWall: {},
  };
  backToEditor = (wallID) => (event) => {
    this.props.navigate(`/wall/index/${wallID}`);
  };

  componentDidMount() {
    setTimeout(() => {
      const { studioWall } = this.props;

       const wallID =
        window.location.href.split("/")[
          window.location.href.split("/").length - 1
        ];
      const sWall =
        studioWall && studioWall.length
          ? studioWall.filter((i) => parseInt(i.id) == parseInt(wallID))[0]
          : {};

      //this.props.studioApps()

      this.setState({
        selectedWall: sWall,
      });
    }, 1500);
  }

  onLoadCreateScene = (event) => { 
    const { scenes, layouts, wallID } = this.props;
    if (layouts && layouts.length > 0) {  
       const selectedLayout = layouts[0];
      const { match } = this.props;
      if (selectedLayout && selectedLayout.id) {  
       // this.setState({ newLayout: selectedLayout }, () =>   
          this.props.CREATE_SCENE(selectedLayout.id, wallID, () => { 
            if (document.getElementById("kt_aside_menu")) {
              var elmnt = document.getElementById("kt_aside_menu");
              if (elmnt.scrollHeight) elmnt.scrollTo(0, elmnt.scrollHeight);
            }
          })
        //);
      }
    }
  };

  render() {
    const {
      location,
      history,
      is_studio_enabled,
      layoutProps,
      wallID,
      studioWall,
      getWidgetWallData
    } = this.props;
    // const { selectedWall, openPop } = this.state;
    // let item = useSelector((state)=>state.studioWall);
    const getMenuItemActive = (url, hasSubmenu = false) => {
      return checkIsActive(location, url)
        ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
        : "";
    };
    //const wallID = location.pathname.replace('/studio/', '').split('/')[0];

    const isPreview = location.pathname.includes("/studio/preview");
    var selectedWall = null;
    if (studioWall && studioWall.length > 0) {
      selectedWall = studioWall.filter((wallFilter) => wallFilter.id == wallID);
    }
    //console.log("studioWall-studioWall", studioWall, wallID, this.props, selectedWall)
    //console.log(isPreview,'isPreview')

    return (
      <>
        {/* begin::Menu Nav */}
        <Nav className="menu-nav">
          {/*begin::1 Level*/}
          <Nav.Link className={`menu-item`} onClick={()=>getWidgetWallData(localStorage.getItem('ownerId'), wallID)} href={`/wall/index/${wallID}`} aria-haspopup="true">
            <FontAwesomeIcon type={'regular'} icon={'arrow-left'}/>
            <span className="menu-text ms-2">Back to editor</span>
          </Nav.Link>
          {/*begin::1 Level*/}
          <Nav.Link className={`menu-item ${getMenuItemActive("/#", false)}`} href={`/studio/${wallID}`} aria-haspopup="true">
            <FontAwesomeIcon type={'regular'} icon={'display'}/>
            <span className="menu-text ms-2 flex-grow-1">Studio</span>
            <span className={`rounded-circle p-1 ${is_studio_enabled != undefined && is_studio_enabled == 0 ? "bg-secondary " : "bg-success"}`}></span> 
          </Nav.Link>
        </Nav>

        {studioWall && studioWall.length > 0 ? (
          
          <Nav className="menu-nav add_scene_">
            {!isPreview ? (
              <div className="menu-item scene-link">
                <span className="menu-text flex-grow-1">Scene List</span>
                <Link className="scene-add-btn btn btn-primary px-2 py-1" onClick={this.onLoadCreateScene} to={`/studio/${wallID}/add/scene`}>
                  Add <FontAwesomeIcon type={'regular'} icon={'plus'} iconClass={'fs-6'}/>
                </Link>
              </div>
              ) : null}
              <Nav.Link className="menu-item scene_tabs d-block mh-100">
                <MenuSideBar history={history} location={location} wallID={wallID}/>
              </Nav.Link>
            </Nav>
        ) : (
          <ul className="add_scene_">
            <li>
              <div className="scene-link p-2">
                <div className="template_list">
                  <div className="template_view">
                    <div className="template_view_head d-flex align-items-center justify-content-between">
                      <div className="sk_line sk_line_30 sk_line_height_8"></div>
                      <div className="sk_line sk_line_30 sk_line_height_8"></div>
                    </div>
                    <div className="template_view_card">
                      <div className="sk_rect btn-min-w h-92 rounded-0"></div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {  
  return {
    scenes: state.scene,
    is_studio_enabled: state.studio.studioWall.is_studio_enabled,
    layouts: state.layout.layouts,
    studioWall: state.studio.studioWall.walls,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    CREATE_SCENE: (layoutID, wallId, callBack) =>
    dispatch(CREATE_SCENE(layoutID, wallId, callBack)),
    USER_STUDIO_WALL: (userID) => dispatch(USER_STUDIO_WALL(userID)),
    getWidgetWallData: (ownerId,wall) => dispatch(getWidgetWallData(ownerId,wall)),
    //studioApps: (data) => dispatch(studioApps(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AsideMenuList);
